import { render, staticRenderFns } from "./OnboardingStepSurvey.vue?vue&type=template&id=64980058"
import script from "./OnboardingStepSurvey.vue?vue&type=script&lang=js"
export * from "./OnboardingStepSurvey.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports